export default __webpack_public_path__ + "static/media/ring.3502ed93.png";